import React from 'react';
import { motion } from 'framer-motion';

const CampaignPopup = ({
  showCampaignPopup,
  campaignForm,
  handleCampaignFormChange,
  handleOfferChange,
  handleSaveCampaignAndDownload,
  closeCampaignPopup,
  savingCampaign,
  isEditMode = false
}) => {
  if (!showCampaignPopup) return null;

  // Wrapper function to pass isEditMode to handleCampaignFormChange
  const handleFormChange = (field, value) => {
    handleCampaignFormChange(field, value, isEditMode);
  };

  return (
    <div className="campaign-popup-overlay">
      <motion.div 
        className="campaign-popup"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
      >
        <div className="campaign-popup-header">
          <h3>{isEditMode ? 'Edit Campaign Information' : 'Campaign Information'}</h3>
          <button onClick={closeCampaignPopup} className="close-popup-btn">×</button>
        </div>

        <div className="campaign-form">
          <div className="form-group">
            <label>Source of Campaign *</label>
            <select
              value={campaignForm.source}
              onChange={(e) => handleFormChange('source', e.target.value)}
              className="form-input"
            >
              <option value="">Select source</option>
              <option value="email">Email</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="SMS">SMS</option>
              <option value="calling">Calling</option>
              <option value="others">Others</option>
            </select>
          </div>

          {campaignForm.source === 'others' && (
            <div className="form-group">
              <label>Source Remarks *</label>
              <input
                type="text"
                value={campaignForm.sourceRemarks}
                onChange={(e) => handleFormChange('sourceRemarks', e.target.value)}
                placeholder="Please specify the source"
                className="form-input"
              />
            </div>
          )}

          <div className="form-group">
            <label>Price per Message (₹) *</label>
            <input
              type="number"
              value={campaignForm.pricePerMessage}
              onChange={(e) => handleFormChange('pricePerMessage', e.target.value)}
              placeholder="Enter price per message"
              className="form-input"
              min="0"
              step="0.01"
            />
          </div>

          <div className="form-group">
            <label>Date of Campaign *</label>
            <input
              type="date"
              value={campaignForm.campaignDate}
              onChange={(e) => handleFormChange('campaignDate', e.target.value)}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>Objective of Campaign *</label>
            <select
              value={campaignForm.objective}
              onChange={(e) => handleFormChange('objective', e.target.value)}
              className="form-input"
            >
              <option value="">Select objective</option>
              <option value="Abandoned">Abandoned</option>
              <option value="Acquisition">Acquisition</option>
              <option value="Retention">Retention</option>
              <option value="Issue orders">Issue orders</option>
              <option value="Dead User">Dead User</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <div className="form-group">
            <label>Offers (Multiple selection allowed)</label>
            <div className="checkbox-group">
              {['1 Rs deal', '10% code', 'Other', 'None'].map(offer => (
                <label key={offer} className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={campaignForm.offers.includes(offer)}
                    onChange={() => handleOfferChange(offer)}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">{offer}</span>
                </label>
              ))}
            </div>
          </div>

          {campaignForm.offers.includes('Other') && (
            <div className="form-group">
              <label>Other Offer Details *</label>
              <input
                type="text"
                value={campaignForm.otherOfferDetails}
                onChange={(e) => handleFormChange('otherOfferDetails', e.target.value)}
                placeholder="Please specify the offer details"
                className="form-input"
              />
            </div>
          )}

          <div className="form-group">
            <label>Coupon Code (if applicable)</label>
            <input
              type="text"
              value={campaignForm.coupon}
              onChange={(e) => handleFormChange('coupon', e.target.value)}
              placeholder="Enter coupon code"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>Campaign Name *</label>
            <input
              type="text"
              value={campaignForm.campaignName}
              onChange={(e) => handleFormChange('campaignName', e.target.value)}
              placeholder={isEditMode ? 'Campaign name' : 'Auto-generated; edit if needed'}
              className="form-input"
            />
          </div>

          <div className="campaign-popup-actions">
            <button
              onClick={closeCampaignPopup}
              className="cancel-btn"
              disabled={savingCampaign}
            >
              Cancel
            </button>
            <button
              onClick={handleSaveCampaignAndDownload}
              className="save-campaign-btn"
              disabled={savingCampaign}
            >
              {savingCampaign ? (
                <>
                  <div className="spinner"></div>
                  {isEditMode ? 'Updating...' : 'Saving...'}
                </>
              ) : (
                isEditMode ? 'Update Campaign' : 'Save & Download'
              )}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default CampaignPopup;

